import { useMemo } from 'react';
import { IntlMessageFormat } from 'intl-messageformat';
import { useI18n } from '@xdocs/ui';
import type { TranslateVars } from '@xdocs/i18n';
import type { EditCatalogKey } from './edit.i18n.js';
import { EDIT_CATALOG } from './edit.i18n.js';

export type EditMessageId = `edit:${EditCatalogKey}`;

const PREFIX_LENGTH = 'edit:'.length;

/** `t()` for the stop-gap `edit:` scope (see `edit.i18n.ts`). */
export function useEditT(): { t: (id: EditMessageId, vars?: TranslateVars) => string } {
  const { locale } = useI18n();

  const t = useMemo(() => {
    return (id: EditMessageId, vars?: TranslateVars): string => {
      const key = id.slice(PREFIX_LENGTH) as EditCatalogKey;
      const raw = EDIT_CATALOG[locale][key] ?? EDIT_CATALOG.en[key];
      if (!vars) return raw;
      const formatted = new IntlMessageFormat(raw, locale).format(vars);
      if (formatted == null) return '';
      if (typeof formatted === 'string') return formatted;
      return Array.isArray(formatted) ? formatted.map(String).join('') : String(formatted);
    };
  }, [locale]);

  return { t };
}
